var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWashingMachine = function SvgWashingMachine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2652 16C10.0473 15.6296 9.85703 15.2028 9.87004 14.8571C9.89763 14.1234 10.8694 13.7338 10.8694 13C10.8694 12.6975 10.6996 12.3289 10.5 12M13.7652 16C13.5473 15.6296 13.357 15.2028 13.37 14.8571C13.3976 14.1234 14.3694 13.7338 14.3694 13C14.3694 12.6975 14.1996 12.3289 14 12M3 6H21M6 5.5V5M9 5.5V5M5 22H19C20.1046 22 21 21.1046 21 20V4C21 2.89543 20.1046 2 19 2H5C3.89543 2 3 2.89543 3 4V20C3 21.1046 3.89543 22 5 22ZM17.5 14C17.5 17.0376 15.0376 19.5 12 19.5C8.96243 19.5 6.5 17.0376 6.5 14C6.5 10.9624 8.96243 8.5 12 8.5C15.0376 8.5 17.5 10.9624 17.5 14Z",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
export default SvgWashingMachine;